import { AlertIcon, Banner, InfoIcon } from '@iheartjane/reefer';

import type { ExclusionAxis } from '../utils/foldRedundantExclusions';

const AXIS_LABELS: Record<ExclusionAxis, string> = {
  brands: 'brands',
  kinds: 'categories',
  lineages: 'lineages',
  weights: 'weights',
};

interface RedundantExclusionsBannerProps {
  axis: ExclusionAxis;
  /**
   * `redundant` exclusions are cleared on save, while `conflicting` ones rule
   * out every inclusion and are left for the user to fix
   */
  reason: 'conflicting' | 'redundant';
}

/** Explains how an exclusion condition overlaps with its inclusions */
export const RedundantExclusionsBanner = ({
  axis,
  reason,
}: RedundantExclusionsBannerProps) => {
  const label = AXIS_LABELS[axis];

  if (reason === 'conflicting') {
    return (
      <Banner
        full
        mt={24}
        variant="error"
        icon={<AlertIcon />}
        label={`You're excluding the same ${label} you want to include. This will match no products, so we suggest updating your rules.`}
      />
    );
  }

  return (
    <Banner
      full
      mt={24}
      variant="info"
      icon={<InfoIcon />}
      label={`You're already including specific ${label}, so excluding ${label} won't change anything. We'll clear these exclusions when you save.`}
    />
  );
};
